import { render, staticRenderFns } from "./DataTableLuis.vue?vue&type=template&id=18b039e5&"
import script from "./DataTableLuis.vue?vue&type=script&lang=js&"
export * from "./DataTableLuis.vue?vue&type=script&lang=js&"
import style0 from "./DataTableLuis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b039e5')) {
      api.createRecord('18b039e5', component.options)
    } else {
      api.reload('18b039e5', component.options)
    }
    module.hot.accept("./DataTableLuis.vue?vue&type=template&id=18b039e5&", function () {
      api.rerender('18b039e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DataTableLuis.vue"
export default component.exports